(function (angular) {
    'use strict';

    angular.module('widget')
        /**
         *
         */
        .controller('WidgetCustomizeCtrl',
            ['$scope', '$stateParams', 'widgetConfig', 'widgetConfigService', 'growlService', '$uibModalInstance', function ($scope, $stateParams, widgetConfig, widgetConfigService, growlService, $uibModalInstance) {

                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                // TODO check if non-hex values will work if not block them if yes - change pattern validation in swagger
                $scope.options = {
                    format: 'hex',
                    placeholder: 'choose color'
                };

                $scope.themeOptions = [{
                    type: 'basic',
                    display: 'Basic',
                    effect: ''
                }, {
                    type: 'bounce',
                    display: 'Bounce',
                    effect: 'bounce'
                }, {
                    type: 'sonar',
                    display: 'Sonar',
                    effect: 'sonar'
                }];

                // Default color settings for widget
                var defaults = {
                    primaryColour: '#2B97EF',
                    secondaryColour: '#eff3f6',
                    primaryTextColour: '#FFF',
                    secondaryTextColour: '#363636',
                };

                $scope.resetToBasic = function resetToBasic() {
                    $scope.selected.introTheme = {
                        newVisitor: "basic",
                        returningVisitor: "basic"
                    };
                };

                getUiConfig(widgetConfig);

                function updateScope() {
                    if (!$scope.selected.primaryColour.startsWith('#')) {
                        $scope.selected.primaryColour = '#' + $scope.selected.primaryColour;
                    }
                    if (!$scope.selected.secondaryColour.startsWith('#')) {
                        $scope.selected.secondaryColour = '#' + $scope.selected.secondaryColour;
                    }
                }

                function updateConfig() {
                    updateScope();
                    widgetConfigService.updateConfig($stateParams.pickedApiSpaceId, $scope.selected)
                        .then(function (result) {
                            $scope.config = result;
                            growlService.success("Settings were successfully updated");
                            $uibModalInstance.close('cancel');
                        })
                        .catch(function (error) {
                            growlService.danger("Cannot update colours, due to: " + error.statusText);
                            $scope.selected = angular.copy($scope.config);
                        });
                }



                function getUiConfig(widgetConfig) {
                    if (widgetConfig) {
                        $scope.config = {
                            primaryColour: widgetConfig.primaryColour || defaults.primaryColour,
                            secondaryColour: widgetConfig.secondaryColour || defaults.secondaryColour,
                            primaryTextColour: widgetConfig.primaryTextColour || defaults.primaryTextColour,
                            secondaryTextColour: widgetConfig.secondaryTextColour || defaults.secondaryTextColour,
                            introTheme: widgetConfig.introTheme
                        };
                        $scope.selected = angular.copy($scope.config);
                        if (!widgetConfig.introTheme || Object.keys(widgetConfig.introTheme).length == 0) {
                            $scope.resetToBasic();
                        }
                    } else {
                        $scope.selected = {
                            primaryColour: defaults.primaryColour,
                            secondaryColour: defaults.secondaryColour,
                            primaryTextColour: defaults.primaryTextColour,
                            secondaryTextColour: defaults.secondaryTextColour,
                            introTheme: {
                                newVisitor: "basic",
                                returningVisitor: "basic"
                            }

                        };
                        $scope.config = angular.copy($scope.selected);
                    }

                }



                $scope.restoreDefaults = function restoreDefaults() {
                    $scope.selected = {
                        primaryColour: defaults.primaryColour,
                        secondaryColour: defaults.secondaryColour,
                        primaryTextColour: defaults.primaryTextColour,
                        secondaryTextColour: defaults.secondaryTextColour
                    };
                };

                $scope.eventApi1 = {
                    onChange: function (api, color, $event) {
                        $scope.selected.primaryColour = color;
                    }
                };

                $scope.eventApi2 = {
                    onChange: function (api, color, $event) {
                        $scope.selected.secondaryColour = color;
                    }
                };

                $scope.updateConfig = updateConfig;
                // for testing
                $scope.getUiConfig = getUiConfig;
                $scope.updateScope = updateScope;

            }]);


})(window.angular);
